import React from "react";
import { useParams, Link } from "react-router-dom";
import { infoPages } from "../mock/mock";

const InfoPage = () => {
  const { slug } = useParams();
  const page = infoPages[slug];

  if (!page) {
    return (
      <main className="max-w-3xl mx-auto px-6 mt-16 min-h-[40vh]">
        <h1 className="font-serif-brand text-3xl text-[#0e2a1e]">Page not found</h1>
        <Link to="/" className="text-[#a4820e] mt-4 inline-block">Back to home →</Link>
      </main>
    );
  }

  return (
    <main className="max-w-3xl mx-auto px-6 mt-12 min-h-[50vh] fade-up">
      <h1 className="font-serif-brand text-4xl font-semibold text-[#0e2a1e]">{page.title}</h1>
      <div className="mt-8 space-y-5">
        {page.body.map((para, i) => (
          <p key={i} className="text-[#0e2a1e]/75 leading-relaxed">
            {para}
          </p>
        ))}
      </div>
      <Link to="/shop" className="text-[#a4820e] font-medium mt-10 inline-block hover:underline">
        ← Continue shopping
      </Link>
    </main>
  );
};

export default InfoPage;
